export type PaymentChannel = 'cash' | 'store_credit' | 'transfer';

export const PAYMENT_CHANNEL_LABELS: Record<PaymentChannel, string> = {
  cash: 'Efectivo',
  store_credit: 'Crédito en tienda',
  transfer: 'Transferencia',
};

export interface PaymentLineItem {
  id: number;
  artId: string | null;
  productName: string;
  variantName: string;
  imageUrl: string | null;
  cost: number;
  soldAmount: number;
  /** Transaction status, e.g. COMPLETED, PENDING */
  status: string;
  /** Sale channel: "in-store", "shopify", or other string | null */
  channel: string | null;
}

export interface PaymentRow {
  id: number;
  consignorName: string;
  /** ISO 8601 string, or null if not yet scheduled */
  scheduledDate: string | null;
  amount: number;
  /** How the consignor receives the payout */
  channel: PaymentChannel;
  paid: boolean;
  items: PaymentLineItem[];
}

export interface ConsignorPaymentsPayload {
  items: PaymentRow[];
  total: number;
  page: number;
  pageSize: number;
}

export type PaymentsOrderBy = 'scheduledDate' | 'consignorName' | 'amount';
export type PaymentsOrderDirection = 'asc' | 'desc';

/** Convenience type for the quick-filter pill bar */
export type PaymentsQuickFilter =
  | 'all'
  | 'pendingToSchedule'
  | 'dueTodayOrOverdue'
  | 'unpaid'
  | 'paid';

export interface CalendarDayLoad {
  /** ISO date string, date-part only: "2024-10-15" */
  date: string;
  /** Total scheduled (unpaid) payout amount already assigned to this date */
  amount: number;
}

export interface ConsignorPaymentsQuery {
  page?: number;
  pageSize?: number;
  orderBy?: PaymentsOrderBy;
  orderDirection?: PaymentsOrderDirection;
  channel?: PaymentChannel;
  paid?: boolean;
  pendingToSchedule?: boolean;
  dueTodayOrOverdue?: boolean;
}
